export const filterCategory = (category, images) => {
    return images.filter(img => {
        return img.category === category;
    });
}

export const mergeImageArrays = (images) => {
    let newArray = [];
    for (let prop in images) {
        newArray.push(images[prop].map((image) => {
            return {
                ...image,
                category: prop,
                imageUrl: image.ImageUrl,
                alternateText: image.AlternateText,
                title: image.Title,
                active: image.Active
            }
        }));
    }
    return [].concat.apply([], newArray);
}

export const uniqueArray = (arr) => {
    return arr.reduce(function (p, c) {
        if (!p.some(function (el) { return el.category === c.category; })) p.push(c);
        return p;
    }, []);
}

export const applyDisplayOrder = (categories, displayOrder) => {
    const order = [];
    categories.forEach(cat => {
        if (cat.name) {
            order[displayOrder[cat.name] - 1] = cat;
        } else {
            order[displayOrder[cat.title] - 1] = cat;
        }
    });
    return order;
}

export const assignAttributeIds = (categories, images) => {
    const getAttributeId = (attributeName) => {
        for (var propName in images) {
            if (propName === attributeName) {
                return images[propName][0].AttributeId;
            }
        }
    }
    let categoriesWithAttributeIds = categories.map(cat => {
        if (cat.subCategories.length > 0) {
            return {
                ...cat,
                subCategories: cat.subCategories.map(c => {
                    return {
                        ...c,
                        attributeId: getAttributeId(c.category)
                    }
                })
            }

        } else {
            return {
                ...cat,
                attributeId: getAttributeId(cat.category)
            };
        }
    });
    return categoriesWithAttributeIds;
}
